import { Spin } from 'antd';
import React from 'react';
import './styles.css';

const Spinner = () => <Spin className="spinner" size="large" />;

export default Spinner;
